import React from 'react';
import { TextInput } from 'react-admin';
import { Grid, Typography } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core';
import { matchingFields } from '../splitmethods/SplitMethodTypeLookups';
import { fieldLengthValidator } from '../../core/utils/index';

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  }
});

const matchingFieldMaxLength = 150;
const matchingField2MaxLength = 256;

const MatchingFields = ({ variant }) => {
  const classes = useStyles();

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerContainer}>
          <Typography variant="h5">Matching Fields</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="externalId1"
            label={matchingFields[0].name}
            variant={variant}
            validate={fieldLengthValidator(matchingFieldMaxLength)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="externalId2"
            label={matchingFields[1].name}
            variant={variant}
            validate={fieldLengthValidator(matchingField2MaxLength)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="externalId3"
            label={matchingFields[2].name}
            variant={variant}
            validate={fieldLengthValidator(matchingFieldMaxLength)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="externalId4"
            label={matchingFields[3].name}
            variant={variant}
            validate={fieldLengthValidator(matchingFieldMaxLength)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="externalId5"
            label={matchingFields[4].name}
            variant={variant}
            validate={fieldLengthValidator(matchingFieldMaxLength)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default MatchingFields;
